// Polyfill para object-fit em navegadores antigos
const objectFitPolyfill = () => {
  // Verificar se object-fit é suportado
  const testEl = document.createElement('div');
  if ('objectFit' in testEl.style) {
    return; // Navegador suporta object-fit nativamente
  }

  console.log('Aplicando polyfill para object-fit...');

  // Polyfill para navegadores antigos
  const applyObjectFitFallback = () => {
    const images = document.querySelectorAll('img[data-object-fit]');
    
    images.forEach(img => {
      const objectFit = img.getAttribute('data-object-fit') || 'cover';
      const objectPosition = img.getAttribute('data-object-position') || 'center';
      
      if (objectFit === 'cover') {
        const parent = img.parentElement;
        
        // Verificar se já foi processado
        if (parent.classList.contains('object-fit-polyfill-applied')) {
          return;
        }
        
        // Marcar como processado
        parent.classList.add('object-fit-polyfill-applied');
        
        // Aplicar estilos de background ao pai
        const imgSrc = img.src || img.getAttribute('src');
        if (imgSrc) {
          parent.style.backgroundImage = `url(${imgSrc})`;
          parent.style.backgroundSize = 'cover';
          parent.style.backgroundPosition = objectPosition;
          parent.style.backgroundRepeat = 'no-repeat';
          
          // Esconder a imagem original
          img.style.opacity = '0';
          img.style.position = 'absolute';
          img.style.top = '0';
          img.style.left = '0';
          img.style.width = '100%';
          img.style.height = '100%';
          
          console.log('Polyfill aplicado para imagem:', imgSrc);
        }
      }
    });
  };

  // Aplicar quando o DOM estiver carregado
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyObjectFitFallback);
  } else {
    applyObjectFitFallback();
  }

  // Observer para aplicar em imagens carregadas dinamicamente
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            const images = node.querySelectorAll ? node.querySelectorAll('img[data-object-fit]') : [];
            if (images.length > 0) {
              setTimeout(applyObjectFitFallback, 100);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

// Função para adicionar atributos data-object-fit às imagens
const addObjectFitAttributes = () => {
  const carouselImages = document.querySelectorAll('.image-carousel-image');
  carouselImages.forEach(img => {
    if (!img.hasAttribute('data-object-fit')) {
      img.setAttribute('data-object-fit', 'cover');
      img.setAttribute('data-object-position', 'center center');
    }
  });
};

export { objectFitPolyfill, addObjectFitAttributes };
